<template>
    <div class="t1-header">
        <div class="navigation">
            <input type="checkbox" class="navigation__checkbox" v-model="checked" id="navi-toggle">
            <label for="navi-toggle" class="navigation__button">
                <span class="navigation__icon">&nbsp;</span>
            </label>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        name: "Header",
        computed: {
            ...mapGetters({
                getDropdown: "getDropdown"
            }),
            checked: {
                get(){
                    return this.getDropdown;
                },
                set(value){
                    this.setDropdown(value);
                }
            }
        },
        methods: {
            ...mapActions(["setDropdown"])
        }
    }
</script>